module.exports = __webpack_public_path__ + "img/icon_copy_momo.1ded756c.svg";